(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a-product-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-product-sticky-atc')) {
		const BOTTOM_HIDE_OFFSET = 400

		class LTAProductStickyAtc extends HTMLElement {
			constructor() {
				super()
				this._cleanups = []
				this._target = null
				this._rafId = null
				this._priceRafId = null
				this._priceObserver = null
				this._loadingTimeout = null
				this._cartVisibilityObserver = null
				this._onScrollOrResize = this._onScrollOrResize.bind(this)
				this._onPriceRelatedChange = this._onPriceRelatedChange.bind(this)
				this._onLegacyVariantChange = this._onLegacyVariantChange.bind(this)
				this._onDomPriceTrigger = this._onDomPriceTrigger.bind(this)
				this._onStickySubmitClick = this._onStickySubmitClick.bind(this)
				this._clearLoading = this._clearLoading.bind(this)
			}

			get sectionId() {
				return this.id.replace(/^stickyATC-/, '')
			}

			connectedCallback() {
				this._cacheTarget()
				this._bindEvents()
				this._observeSubscriptionPrices()
				this._updateVisibility()
				this._queuePriceSync()
			}

			disconnectedCallback() {
				if (this._rafId) {
					cancelAnimationFrame(this._rafId)
					this._rafId = null
				}
				if (this._priceRafId) {
					cancelAnimationFrame(this._priceRafId)
					this._priceRafId = null
				}
				if (this._priceObserver) {
					this._priceObserver.disconnect()
					this._priceObserver = null
				}
				if (this._cartVisibilityObserver) {
					this._cartVisibilityObserver.disconnect()
					this._cartVisibilityObserver = null
				}
				this._clearLoadingTimeout()
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
				this._target = null
			}

			_cacheTarget() {
				const observeId = this.dataset.observe
				this._target = observeId ? document.getElementById(observeId) : null
			}

			_getProductContainer() {
				return (
					document.getElementById(`ProductTemplate--${this.sectionId}`) ||
					document.getElementById(`shopify-section-${this.sectionId}`) ||
					document.getElementById(`Subscriptions-${this.sectionId}`)?.closest('.shopify-section')
				)
			}

			_onScrollOrResize() {
				if (this._rafId) return
				this._rafId = requestAnimationFrame(() => {
					this._rafId = null
					this._updateVisibility()
				})
			}

			_updateVisibility() {
				if (!this._target?.isConnected) {
					this._cacheTarget()
				}

				if (!this._target) {
					this.classList.remove('is-visible')
					return
				}

				const atcRect = this._target.getBoundingClientRect()
				const scrolledPastAtc = atcRect.bottom < 0
				const distanceFromBottom =
					document.documentElement.scrollHeight - (window.scrollY + window.innerHeight)
				const awayFromBottom = distanceFromBottom > BOTTOM_HIDE_OFFSET

				this.classList.toggle('is-visible', scrolledPastAtc && awayFromBottom)
			}

			_bindEvents() {
				window.addEventListener('scroll', this._onScrollOrResize, { passive: true })
				window.addEventListener('resize', this._onScrollOrResize, { passive: true })
				document.addEventListener('l:variant:changed', this._onPriceRelatedChange)
				document.addEventListener('l:quantity:changed', this._onPriceRelatedChange)
				document.addEventListener('l:sellingPlan:changed', this._onPriceRelatedChange)
				document.addEventListener('theme:variant:change', this._onLegacyVariantChange)
				document.addEventListener('change', this._onDomPriceTrigger, true)
				document.addEventListener('input', this._onDomPriceTrigger, true)
				// Capture: legacy theme cart handler uses closest('form'), which fails for form= buttons
				this.addEventListener('click', this._onStickySubmitClick, true)
				document.addEventListener('rebuy:cart.add', this._clearLoading)
				document.addEventListener('l:product:added', this._clearLoading)
				document.addEventListener('theme:cart:added', this._clearLoading)
				this._observeRebuyCartVisible()

				this._cleanups.push(() => {
					window.removeEventListener('scroll', this._onScrollOrResize)
					window.removeEventListener('resize', this._onScrollOrResize)
					document.removeEventListener('l:variant:changed', this._onPriceRelatedChange)
					document.removeEventListener('l:quantity:changed', this._onPriceRelatedChange)
					document.removeEventListener('l:sellingPlan:changed', this._onPriceRelatedChange)
					document.removeEventListener('theme:variant:change', this._onLegacyVariantChange)
					document.removeEventListener('change', this._onDomPriceTrigger, true)
					document.removeEventListener('input', this._onDomPriceTrigger, true)
					this.removeEventListener('click', this._onStickySubmitClick, true)
					document.removeEventListener('rebuy:cart.add', this._clearLoading)
					document.removeEventListener('l:product:added', this._clearLoading)
					document.removeEventListener('theme:cart:added', this._clearLoading)
				})
			}

			_observeRebuyCartVisible() {
				if (this._cartVisibilityObserver) return

				this._cartVisibilityObserver = new MutationObserver(() => {
					if (this._isRebuyCartVisible()) this._clearLoading()
				})

				this._cartVisibilityObserver.observe(document.documentElement, {
					attributes: true,
					attributeFilter: ['class'],
				})
				this._cartVisibilityObserver.observe(document.body, {
					attributes: true,
					attributeFilter: ['class'],
				})
			}

			_isRebuyCartVisible() {
				return (
					document.documentElement.classList.contains('rebuy-cart-visible') ||
					document.body.classList.contains('rebuy-cart-visible') ||
					!!document.querySelector('#rebuy-cart.is-visible, #rebuy-cart[aria-hidden="false"], .rebuy-cart-visible')
				)
			}

			_setLoading(isLoading) {
				const submit = this.querySelector('[data-sticky-submit]')
				if (!submit) return

				submit.classList.toggle('is-loading', isLoading)
				submit.setAttribute('aria-busy', isLoading ? 'true' : 'false')

				if (isLoading) {
					this._clearLoadingTimeout()
					this._loadingTimeout = setTimeout(() => this._clearLoading(), 8000)
				} else {
					this._clearLoadingTimeout()
				}
			}

			_clearLoading() {
				this._setLoading(false)
			}

			_clearLoadingTimeout() {
				if (!this._loadingTimeout) return
				clearTimeout(this._loadingTimeout)
				this._loadingTimeout = null
			}

			_onStickySubmitClick(event) {
				const submit = event.target.closest('[data-sticky-submit]')
				if (!submit || !this.contains(submit) || submit.disabled) return

				if (submit.classList.contains('is-loading')) {
					event.preventDefault()
					event.stopPropagation()
					return
				}

				this._setLoading(true)

				if (!this.hasAttribute('data-legacy')) return

				event.preventDefault()
				event.stopPropagation()

				const mainAtc = document.getElementById(`AddToCart--${this.sectionId}`)
				if (mainAtc && !mainAtc.disabled) {
					mainAtc.click()
					return
				}

				const form = document.getElementById(submit.getAttribute('form') || '')
				if (form?.requestSubmit) {
					form.requestSubmit()
				} else {
					form?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
				}
			}

			_observeSubscriptionPrices() {
				const subs = document.getElementById(`Subscriptions-${this.sectionId}`)
				if (!subs || this._priceObserver) return

				this._priceObserver = new MutationObserver(() => this._queuePriceSync())
				this._priceObserver.observe(subs, {
					subtree: true,
					characterData: true,
					childList: true,
				})
			}

			_onDomPriceTrigger(event) {
				if (!this.isConnected) return
				const target = event.target
				if (!(target instanceof Element)) return

				const container = this._getProductContainer()
				if (!container?.contains(target)) return

				const isQty =
					target.matches('[data-qty-input]') || target.getAttribute('name') === 'quantity'
				const isSellingPlan = target.getAttribute('name') === 'selling_plan'
				if (!isQty && !isSellingPlan) return

				this._queuePriceSync()
			}

			_onPriceRelatedChange(event) {
				if (!this.isConnected) return

				const { sectionId } = event.detail || {}
				if (sectionId && sectionId !== this.sectionId) return

				const variant = event.detail?.variant
				if (variant !== undefined) {
					this._syncAvailability(variant)
				}

				this._queuePriceSync()
			}

			_onLegacyVariantChange(event) {
				if (!this.isConnected || !this.hasAttribute('data-legacy')) return

				const variant = event.detail?.variant
				this._syncAvailability(variant)
				this._queuePriceSync()

				const media = this.querySelector('[data-sticky-media] img')
				if (media && variant?.featured_image?.src) {
					media.src = variant.featured_image.src
					if (variant.featured_image.alt) media.alt = variant.featured_image.alt
				}
			}

			_queuePriceSync() {
				if (this._priceRafId) cancelAnimationFrame(this._priceRafId)
				// Double rAF so subscription qty/price handlers update DOM first
				this._priceRafId = requestAnimationFrame(() => {
					this._priceRafId = requestAnimationFrame(() => {
						this._priceRafId = null
						this._syncPriceFromMainAtc()
					})
				})
			}

			_getSubscriptionPriceText() {
				const subs = document.getElementById(`Subscriptions-${this.sectionId}`)
				if (!subs) return ''

				const checked = subs.querySelector('[name="selling_plan"]:checked')
				const isSubscription = Boolean(checked?.value)
				const priceEl = isSubscription
					? subs.querySelector('[data-selling-price]')
					: subs.querySelector('[data-variant-price]')

				return priceEl?.textContent?.trim() || ''
			}

			_syncPriceFromMainAtc() {
				const sectionId = this.sectionId
				let sourcePrice = this._getSubscriptionPriceText()

				if (!sourcePrice && this.hasAttribute('data-legacy')) {
					const legacyPrice = document.querySelector(
						`#ProductTemplate--${sectionId} [data-price-wrapper] [data-product-price], #AddToCartForm--${sectionId} [data-product-price]`
					)
					sourcePrice = legacyPrice?.textContent?.trim() || ''
				}

				if (!sourcePrice && !this.hasAttribute('data-legacy')) {
					const mainSubmitPrice = document.querySelector(
						`#ProductSubmitButton-${sectionId} [data-product-normal-price]`
					)
					const scopedPrice = document.querySelector(`[data-product-normal-price="${sectionId}"]`)
					sourcePrice =
						mainSubmitPrice?.textContent?.trim() ||
						(scopedPrice && !this.contains(scopedPrice) ? scopedPrice.textContent.trim() : '') ||
						''

					if (!sourcePrice && typeof l_formatMoney === 'function') {
						const productForm = document.querySelector(`l-product-form[data-section-id="${sectionId}"]`)
						const pricePerUnit = Number(productForm?.dataset?.defaultPricePerUnit)
						const qtyInput = document.querySelector(
							`#Quantity-${sectionId}, #product-form-${sectionId} [name="quantity"]`
						)
						const quantity = Number(qtyInput?.value) || 1
						if (pricePerUnit) sourcePrice = l_formatMoney(pricePerUnit * quantity)
					}
				}

				if (sourcePrice) this._setPrices(sourcePrice)
			}

			_syncAvailability(variant) {
				const submit = this.querySelector('[data-sticky-submit]')
				const label = this.querySelector('[data-sticky-atc-label]')
				if (!submit || !label) return

				const strings = window.theme?.strings || {}
				const atcLabel = strings.add_to_cart || 'Add to cart'
				const soldOutLabel = strings.sold_out || 'Sold out'
				const unavailableLabel = strings.unavailable || 'Unavailable'
				const preorderLabel = strings.preorder || 'Pre-order'

				if (!variant) {
					submit.disabled = true
					label.textContent = unavailableLabel
					this._togglePriceInButton(false)
					return
				}

				if (!variant.available) {
					submit.disabled = true
					label.textContent = soldOutLabel
					this._togglePriceInButton(false)
					return
				}

				submit.disabled = false
				label.textContent = this.hasAttribute('data-preorder') ? preorderLabel : atcLabel
				this._togglePriceInButton(true)
			}

			_setPrices(formatted) {
				this.querySelectorAll('[data-sticky-price]').forEach((el) => {
					const nested = el.querySelector('[data-product-price]')
					if (nested) {
						nested.textContent = formatted
					} else {
						el.textContent = formatted
					}
				})
			}

			_togglePriceInButton(show) {
				const dot = this.querySelector('.l-pStickyAtc__submit-dot')
				const price = this.querySelector('.l-pStickyAtc__submit-price')
				if (dot) dot.hidden = !show
				if (price) price.hidden = !show
			}
		}

		customElements.define('l-product-sticky-atc', LTAProductStickyAtc)
	}
  } catch(e) { console.error(e); }
})();

})();
